  
<template>
  <v-app id="inspire">
    <!-- BARRA SUPERIOR APP-->
    <v-app-bar
      v-show="$vuetify.breakpoint.width < 900"
      color="#2d70a3"
      app
      align="center"
      justify="center"
    >
      <a
        @click="redirecionarPagina('http://joaocesarmattogrosso.com.br/')"
        title="Voltar ao Site"
      >
        <v-icon x-large color="#feca26">mdi-home</v-icon
        ><strong style="color: #feca26;font: inherit;">Início</strong>
      </a>
      <v-spacer></v-spacer>
      <a @click="signoutButtonPressed" v-show="user" title="sair">
        <v-icon x-large color="#feca26">mdi-location-exit</v-icon
        ><strong style="color: #feca26;font: inherit;">Sair</strong>
      </a>
    </v-app-bar>
    <!-- BARRA SUPERIOR APP-->
    <!-- BARRA SUPERIOR SITE -->
    <v-app-bar
      v-show="$vuetify.breakpoint.width > 900"
      color="#2d70a3"
      app
      align="center"
      justify="center"
      :height="$vuetify.breakpoint.width > 1500 ? 80 : 60"
    >
      <a
        @click="redirecionarPagina('http://joaocesarmattogrosso.com.br/')"
        title="Voltar ao Site"
      >
        <v-icon  color="#feca26">mdi-home</v-icon
        ><strong style="color: #feca26; font: inherit; font-size: 110%"
          >INÍCIO</strong
        >
      </a>
      <v-spacer></v-spacer>
      <a @click="signoutButtonPressed" v-show="user" title="sair">
        <v-icon x-large color="#feca26">mdi-location-exit</v-icon
        ><strong style="color: #feca26; font: inherit; font-size: 110%">SAIR</strong>
      </a>
    </v-app-bar>
    <!-- BARRA SUPERIOR SITE-->

    <!-- VIEWS -->
    <v-main>
      <!-- DIALOG CADASTRO Perfil -->
      <v-dialog
        persistent
        v-model="dialogPerfil"
        :fullscreen="$vuetify.breakpoint.width < 900"
        :max-width="$vuetify.breakpoint.width < 900 ? 1000 : 400"
        transition="dialog-bottom-transition"
      >
        <Perfil />
      </v-dialog>

      <!-- DIALOG CADASTRO Perfil -->

      <DemandaSite v-if="user && $vuetify.breakpoint.width > 900" />
      <Demanda v-if="user && $vuetify.breakpoint.width < 900" />

      <Login v-if="!user" />

      <v-overlay :value="overlay">
        <img
          :src="require('@/Arquivos/onload.gif')"
          style="width: 70px; height: 70px"
        />
      </v-overlay>
    </v-main>
    <!--VIEWS -->

    <!-- BARRA INFERIOR -->
    <v-footer absolute padless height="0px">
      <v-bottom-navigation
        id="home"
        color="blue"
        grow
        :background-color="'#2d70a3'"
      >
        <v-btn href="https://www.instagram.com/jcmattogrosso/" target="_blank">
          <v-icon large color="#feca26">mdi-instagram</v-icon>
        </v-btn>

        <v-btn
          href="https://www.facebook.com/jcmattogrosso/?ref=page_internal"
          target="_blank"
        >
          <v-icon large color="#feca26">mdi-facebook</v-icon>
        </v-btn>

        <v-btn
          href="http://api.whatsapp.com/send?1=pt_BR&phone=5567999044045"
          target="_blank"
        >
          <v-icon large color="#feca26">mdi-whatsapp</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-footer>
    <!-- BARRA INFERIOR -->

    <!-- MENSAGEM -->
    <v-snackbar elevation="13" v-model="alert">
      {{ msgAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="fecharAlert()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- MENSAGEM -->
  </v-app>
</template>


<script>
import firebase from "firebase";

export default {
  props: {
    source: String,
  },

  components: {
    DemandaSite: () => import("@/views/site/DemandaSite"),
    Demanda: () => import("@/views/site/Demanda"),
    Login: () => import("@/views/Login"),
    Perfil: () => import("@/views/Perfil"),
  },
  data: () => ({
    perfil: {
      id: "",
      email: "",
      primeiroNome: "",
      segundoNome: "",
      dataNascimento: "",
      endereco: "",
      bairro: "",
      cidade: "",
      regiao: "",
      longitude: "",
      latitude: "",
      telefone: "",
      profissao: "",
      cpf: "",
      img: "",
    },
    dialogPerfil: false,
    postFontSize: 1,
    telaLogin: false,
    isTransparent: false,
    direction: "top",
    right: true,
    bottom: true,

    btn3em1: false,
    large: true,

    overlay: false,
    barColor: "",
    user: null,

    alert: false,
    msgAlert: "",
    arquivo: null,

    drawer: false,
  }),

  watch: {
    user() {
      this.abrirDialogCadastroPerfil();
      if (this.user) {
        // window.location.href = "Home";
      }
    },
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
    });
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
    });
    this.chamaOverlay(1000);
  },
  methods: {
    redirecionarPagina(pagina) {
      window.location.href = "" + pagina;
    },
    async chamaOverlay(val2) {
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      }, val2);
    },
    async mensagemAlerta(msg) {
      this.fecharAlert();
      this.msgAlert = "\n" + msg + "\n";
      this.alert = true;
    },
    fecharAlert() {
      this.alert = false;
      this.msgAlert = "";
    },
    signoutButtonPressed(e) {
      // this.user = false;
      e.stopPropagation();
      firebase.auth().signOut();
      window.location.href = "Home";
      //this.$router.replace("/");
    },

    // CADASTRO e EDIÇÂO PERFIL
    async abrirDialogAtualizarPerfil() {
      if (!this.user) {
        this.telaLogin = true;
        this.drawer = !this.drawer;
        return;
      }

      await firebase
        .firestore()
        .collection("perfil")
        .where("email", "==", firebase.auth().currentUser.email)
        .onSnapshot((snap) => {
          var alterar = false;
          snap.forEach((doc) => {
            this.perfil = doc.data();
            alterar = true;
          });
          this.dialogPerfil = alterar;
        });
    },
    async abrirDialogCadastroPerfil() {
      console.log(firebase.auth())
      await firebase
        .firestore()
        .collection("perfil")
        .where("email", "==", firebase.auth().currentUser.email)
        .onSnapshot((snap) => {
          var cadastrar = true;
          snap.forEach((doc) => {
            this.perfil = doc.data();
            cadastrar = false;
          });
          this.dialogPerfil = cadastrar;
        });
    },

    // CADASTRO e EDIÇÂO PERFIL
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// Cor do Botão fica em state.js que obtem a cor de theme.js
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }
}

.transparent {
  background-color: white !important;
  opacity: 0.65;
  border-color: transparent !important;
}

//parte botao q vira 3
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

#lateral .v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0 0 16px 16px;
}
//parte botao q vira 3
</style>


